import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Home from "../pages/home/page";
import BrandReviewPage from "../pages/brand-review/page";
import SeoPage from "../pages/seo/SeoPage";
import { seoPages } from "../pages/seo/content";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...seoPages.map((page) => ({
    path: `/${page.slug}`,
    element: <SeoPage slug={page.slug} />,
  })),
  {
    path: "/:slug",
    element: <BrandReviewPage />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
